













































































































































import { Component, Prop, Vue, Mixins, Watch, Emit } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
import Combobox from '../../core/components/Combobox.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import PlusEyeButtons from '../../core/components/PlusEyeButtons.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';

import {
    // AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
    // StoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';
import {
    splitStringByIndex,
    getCompanyItemById,
    addItemsToListIfAreNotAdded,
    removeItemsFromList,
    getIdsFromList,
    matchedIndexIdInArray,
    sortObjectByPropertyName,
    EventBus,
    TypeEventBus,
    getIndexFromList
} from '../../core/utils';
import { InsuranceServices } from '../api/InsuranceServices';

@Component({
    components: {
        multiselect,
        Combobox,
        Button,
        Input,
        DatePickerRange,
        SimpleTable,
        TableArrows,
        PlusEyeButtons,
        DeleteConfirmation
    }
})
export default class ModalInsuranceCompany extends Mixins(
    NotificationStoreHelper,
    CompanyStoreHelper,
    RootStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({ default: false }) editing: boolean;
    @Prop({ default: {} }) patchData: object;
    @Prop({ default: -1 }) companyIdToPreselect: number;
    @Prop({
        default() {
            return [];
        }
    })
    optionsFarmings: Array<object>;

    modalTitle: string = '';
    topic: string = 'Empresa Aseguradora';
    searchAvailableCompanies: string = '';

    //selectors
    companySelected: any = null;
    cropTypeSelected: any = null;
    harvestSelected: any = null;
    securedCompanySelected: any = null;

    //selectors reset values
    companyRV: boolean = false;
    companyRv: boolean = false;

    loadingAvailableCompanies: boolean = false;

    itemsAvailableCompanies: Array<object> = [];
    itemsAvailableCompaniesSelected: Array<object> = [];
    itemsSelectedCompanies: Array<object> = [];
    itemsAvailableCheckedCompanies: Array<object> = [];

    headersAvailableCompanies: any = [
        {
            text: 'Empresa',
            value: 'name',
            sortable: true
        }
        //   {
        //     text: 'Acciones',
        //     value: 'actions',
        //     align: 'center',
        //     sortable: true
        //   },
    ];

    headersSelectedFarmings: any = [
        {
            text: 'Empresa',
            value: 'name',
            sortable: true
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        }
    ];

    dateRangeSelected: any = [];
    allAvailableFarmings: Array<object> = [];
    counter: number = 0;

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    canEditMainCompany: boolean = true;

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    pendingRequestInsuranceFarming: boolean = false;

    editCompanyHarvest: boolean = false;

    patchCompanyFarming: object = {};

    updateCompanySelected(value) {
        this.companySelected = value;
    }
    updateCompanyRV(value) {
        this.companyRV = value;
    }

    addCompanyToSelectedOnes() {
        this.itemsSelectedCompanies = addItemsToListIfAreNotAdded(
            this.itemsSelectedCompanies,
            this.itemsAvailableCompaniesSelected,
            'id'
        );
        this.itemsAvailableCompaniesSelected = [];
    }

    removeCompanySelected() {
        this.updateSelectedCompanies(this.itemsAvailableCheckedCompanies);
        this.itemsAvailableCheckedCompanies = [];
    }

    updateSelectedCompanies(newItems) {
        this.itemsSelectedCompanies = removeItemsFromList(this.itemsSelectedCompanies, newItems, 'id');
    }

    mounted() {
        this.setModalTitle();

        this.$nextTick(() => {
            this.setUserCompanies();
            this.setAvailableCompanies();
            this.loadPatchData();
        });
    }

    loadPatchData() {
        if (this.editing) {
            let indexInsuranceCompany = matchedIndexIdInArray(this.$_getCompanies, this.patchData['company']);
            if (indexInsuranceCompany !== -1) {
                this.companySelected = this.$_getCompanies[indexInsuranceCompany];
                this.itemsSelectedCompanies = this.patchData['secured_companies'];
                this.modalTitle += ': <b>' + this.companySelected['name'] + '</b>';
            }
        }else{
            this.preselectInsuranceCompany();
        }
    }

    preselectInsuranceCompany(){
        let indexInCompaniesList = getIndexFromList(this.$_getCompanies, 'id', this.companyIdToPreselect);
        if(indexInCompaniesList !== -1){
            this.updateCompanySelected(this.$_getCompanies[indexInCompaniesList])
            this.canEditMainCompany = false;
        }
    }

    setUserCompanies() {
        // this.companies = this.$_getCompanies.sort(sortObjectByPropertyName('name'));
    }

    setAvailableCompanies() {
        this.itemsAvailableCompanies = this.$_getCompanies;
    }

    updateAvailableCompaniesSelectedRows(rows) {
        this.itemsAvailableCompaniesSelected = rows;
    }

    updateCompaniesToRemove(rows) {
        this.itemsAvailableCheckedCompanies = rows;
    }

    excludeCompanySelected(item) {
        this.updateSelectedCompanies([item]);
    }

    updatesearchAvailableCompanies(value) {
        this.searchAvailableCompanies = value;
    }

    setModalTitle() {
        let title = this.editing ? 'Modificar ' : 'Crear ';
        title += this.topic;
        if (this.editing) {
            // title += ': <b>' + this.patchData['name'] + '</b>'
        }
        this.modalTitle = title;
    }

    getData() {
        let data = {
            company: this.companySelected['id'],
            secured_companies: getIdsFromList(this.itemsSelectedCompanies)
        };
        if (this.editing) {
            this.$set(data, 'id', this.patchData['id']);
        }
        return data;
    }

    submitCompany() {
        let formData = this.getData();
        if (!this.editing) {
            this.postCompany(formData);
        } else {
            this.patchCompany(formData);
        }
    }

    postCompany(formData) {
        this.showLoadingDialog('Creando Empresa Aseguradora');
        InsuranceServices.postInsuranceCompany(formData)
            .then(res => {
                let msg = res['message'] !== undefined ? res['message'] : 'Empresa Aseguradora creada con éxito';
                this.showSuccessLoadingDialog(res, msg);
                this.$set(res, 'name', this.companySelected['name']);
                this.addNewInsuranceCompany(res);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la empresa aseguradora');
            });
    }

    patchCompany(formData) {
        this.showLoadingDialog('Modificando Empresa Aseguradora');
        InsuranceServices.patchInsuranceCompany(formData)
            .then(res => {
                let msg =
                    res['data']['message'] !== undefined ? res['data']['message'] : 'Empresa Aseguradora modificada';
                this.$set(res['data'], 'name', this.companySelected['name']);
                this.showSuccessLoadingDialog(res.data, msg);
                this.updateInsuranceCompany(res['data']);
                // this.$emit('update-insurance-company', res['data']['insurance_farming']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo modificar la empresa aseguradora');
            });
    }

    addNewInsuranceCompany(newInsuranceCompany) {
        let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
        this.$_setInsuranceProperties([]);
        updatedProperties['insurance_companies'].push(newInsuranceCompany);
        updatedProperties['insurance_companies'] = updatedProperties['insurance_companies'].sort(
            sortObjectByPropertyName('name')
        );
        this.$_setInsuranceProperties(updatedProperties);
        let indexCompany = matchedIndexIdInArray(updatedProperties['insurance_companies'], newInsuranceCompany['id']);
        if (indexCompany !== -1) {
            this.$emit('select-new-insurance-company', updatedProperties['insurance_companies'][indexCompany]);
        }
    }

    updateInsuranceCompany(newInsuranceCompany) {
        let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
        let indexToUpdate = matchedIndexIdInArray(updatedProperties['insurance_companies'], newInsuranceCompany['id']);
        if (indexToUpdate !== -1) {
            this.$_setInsuranceProperties([]);
            this.$set(
                updatedProperties['insurance_companies'][indexToUpdate],
                'secured_companies',
                newInsuranceCompany['secured_companies']
            );
            updatedProperties['insurance_companies'] = updatedProperties['insurance_companies'].sort(
                sortObjectByPropertyName('name')
            );
            this.$_setInsuranceProperties(updatedProperties);

            setTimeout(() => {
                this.$emit(
                    'update-secured-companies',
                    updatedProperties['insurance_companies'][indexToUpdate]['secured_companies']
                );
            }, 100);
        }
    }

    showLoadingDialog(msg) {
        this.$_showLoadingDialog(msg);
    }

    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        // this.enableScrollLoadingDialog();
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.showLoadingDialog('Eliminando ' + this.topic);

            InsuranceServices.deleteInsuranceCompany(this.patchData['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = this.topic + ' eliminada con éxito';
                    }

                    this.showSuccessLoadingDialog(response.data, 'Empresa aseguradora eliminada con éxito');
                    this.removeInsuranceCompanyFromProperties(this.patchData['id']);
                })
                .catch(err => {
                    this.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        } else {
            this.confirmationDelete = false;
        }
    }

    removeInsuranceCompanyFromProperties(insuranceCompanyId) {
        let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
        let updatedInsuranceCompanies = updatedProperties['insurance_companies'];
        let updatedInsuranceFarmings = updatedProperties['insurance_farmings'];
        let indexCompanyToRemove = matchedIndexIdInArray(updatedInsuranceCompanies, insuranceCompanyId);
        let farmingsToRemove = updatedInsuranceFarmings.filter(item => item['insurance_company'] == insuranceCompanyId);
        this.$_setInsuranceProperties([]);
        if (indexCompanyToRemove !== -1) {
            //remuevo la insurance company from properties insurance_companies list
            updatedInsuranceCompanies.splice(indexCompanyToRemove, 1);
        }

        //quito las insurance_farming de la empresa aseguradora eliminada
        for (let index = 0; index < farmingsToRemove.length; index++) {
            const insuranceFarming = farmingsToRemove[index];
            let indexInInsuranceFarmingList = matchedIndexIdInArray(updatedInsuranceFarmings, insuranceFarming['id']);

            if (indexInInsuranceFarmingList !== -1) {
                updatedInsuranceFarmings.splice(indexInInsuranceFarmingList, 1);
            }
        }
        this.$_setInsuranceProperties(updatedProperties);
        this.$emit('deleted-insurance-company');
        EventBus.$emit(TypeEventBus.INSURANCE_FARMING_UPDATE_FARMING_LIST);
    }

    deleteCompany() {
        this.deleteModalTitle = 'Eliminar Empresa Aseguradora';
        this.deleteBody =
            '¿Está seguro que desea eliminar la Empresa Aseguradora ' +
            '<b>"' +
            this.companySelected['name'] +
            '"</b>?';
        this.confirmationDelete = true;
    }

    modifyCompany(item) {
        // this.$set(item, 'isLoading', true);
        // InsuranceServices.getFarmingDetail(item['id'])
        //     .then((res) => {
        //         this.patchCompanyFarming = res;
        //         this.editCompanyHarvest = true;
        //         this.visibilityModalCompanyHarvest(true);
        //         this.$set(item, 'isLoading', false);
        //     })
        //     .catch((err) => {
        //         // this.loadingAvailableCompanies = false;
        //         this.$set(item, 'isLoading', false);
        //     })
    }

    get checkIfFormIsValid() {
        return this.companySelected !== null ? true : false;
    }

    updateCompanyFarming(updatedItem) {
        // console.log('update company', updatedItem);
    }

    @Emit()
    closeModal() {}

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }
}
